import caller from "../../helpers/caller";

export default async function deleteCustomerQuestionnaire(api, id) {
  // api.delete recebe (url, config)
  return await caller(api.delete, "/customer_questionnaire/delete", {params: {id}});
}
